/*
  adeqo-policy.js — leesbaar maken van de beleidsdocumenten.

  De policy-teksten komen uit de Shopify-admin en zijn niet in Liquid te bewerken.
  Ze zijn ooit uit Word en uit de oude Shogun-pagebuilder geplakt, waardoor de
  koppenstructuur ontbreekt: de algemene voorwaarden bestaan uit 162 alinea's met
  nul koppen, en de achttien artikeltitels zijn alleen vetgedrukte alinea's.

  Deze module herstelt dat aan de clientkant en bouwt daar een inhoudsopgave op.
  Zonder JS blijft het document gewoon leesbaar, alleen zonder navigatie: alle
  ingrepen hieronder zijn navigatie en opmaak, nooit tekst.
*/
(function () {
  'use strict';

  var DESKTOP = '(min-width: 1024px)';
  var SCROLL_ANCHOR = 130; // px onder de bovenkant; net onder de sticky header

  /* Een alinea telt als kop wanneer álle tekst erin vet staat. Een zin die op een
     punt eindigt is geen kop maar een uitroep ("Klanttevredenheid staat bij ons
     voorop."), dus die blijft alinea. */
  function isWholeBold(el) {
    var text = el.textContent.trim();
    if (text.length < 2 || text.length > 120) return false;
    if (text.slice(-1) === '.') return false;
    if (!el.querySelector('strong, b')) return false;

    var clone = el.cloneNode(true);
    Array.prototype.forEach.call(clone.querySelectorAll('strong, b'), function (node) {
      node.parentNode.removeChild(node);
    });
    return clone.textContent.trim() === '';
  }

  function replaceTag(el, tagName) {
    var next = document.createElement(tagName);
    next.innerHTML = el.innerHTML;
    Array.prototype.forEach.call(el.attributes, function (attr) {
      if (attr.name === 'style') return;
      next.setAttribute(attr.name, attr.value);
    });
    el.parentNode.replaceChild(next, el);
    return next;
  }

  function slugify(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }

  function ensureId(el, used) {
    if (el.id && !used[el.id]) {
      used[el.id] = true;
      return el.id;
    }
    var base = slugify(el.textContent) || 'onderdeel';
    var id = base;
    var n = 2;
    while (used[id] || (id !== el.id && document.getElementById(id))) {
      id = base + '-' + n++;
    }
    el.id = id;
    used[id] = true;
    return id;
  }

  /* Brede tabellen (de verzendtarieven) scrollen binnen hun eigen kader, zodat de
     pagina zelf nooit horizontaal meebeweegt. */
  function wrapTables(body) {
    Array.prototype.forEach.call(body.querySelectorAll('table'), function (table) {
      var parent = table.parentNode;
      if (parent && parent.classList && parent.classList.contains('adeqo-policy__table-scroll')) return;
      var wrap = document.createElement('div');
      wrap.className = 'adeqo-policy__table-scroll';
      parent.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  /* De algemene voorwaarden openen met een inhoudsopgave zonder links: een vet
     "Inhoudsopgave" gevolgd door één alinea met achttien <br>-regels. Zodra we een
     échte inhoudsopgave tonen, is dat blok dubbelop. */
  function hideInlineToc(body) {
    var candidates = body.querySelectorAll('h2, h3, p');
    for (var i = 0; i < candidates.length; i++) {
      var el = candidates[i];
      if (el.textContent.trim().toLowerCase() !== 'inhoudsopgave') continue;

      var next = el.nextElementSibling;
      if (!next || next.querySelectorAll('br').length < 3) continue;
      if (!/^\s*artikel\s+\d/i.test(next.textContent)) continue;

      el.classList.add('adeqo-policy__inline-toc-hidden');
      next.classList.add('adeqo-policy__inline-toc-hidden');
      return;
    }
  }

  /* De teksten staan vol met alinea's die alleen een &nbsp; bevatten en met
     alinea's die met een <br> beginnen: handmatige witruimte uit Word en Shogun.
     Naast een echte koppenstructuur levert dat dubbele gaten op. */
  function stripFillerWhitespace(body) {
    Array.prototype.forEach.call(body.querySelectorAll('p'), function (p) {
      if (p.querySelector('img, table')) return;

      if (p.textContent.replace(/\u00a0/g, '').trim() === '') {
        p.classList.add('adeqo-policy__blank');
        return;
      }

      while (p.firstChild) {
        var node = p.firstChild;
        var isBreak = node.nodeType === 1 && node.tagName === 'BR';
        var isBlankText = node.nodeType === 3 &&
          node.nodeValue.replace(/\u00a0/g, '').trim() === '';
        if (!isBreak && !isBlankText) break;
        p.removeChild(node);
      }
    });
  }

  function normalise(body, minHeadings) {
    var existing = body.querySelectorAll('h2, h3, h4').length;

    // Eén H1 per pagina: de paginatitel. Een H1 in de tekst zakt naar H2.
    Array.prototype.forEach.call(body.querySelectorAll('h1'), function (h1) {
      replaceTag(h1, 'h2');
    });

    if (existing >= minHeadings) return;

    Array.prototype.forEach.call(body.querySelectorAll('p'), function (p) {
      if (p.closest('li, td, th, blockquote')) return;
      if (!isWholeBold(p)) return;
      replaceTag(p, 'h2');
    });
  }

  function collectHeadings(body) {
    var nodes = Array.prototype.filter.call(
      body.querySelectorAll('h2, h3, h4'),
      function (el) {
        return el.textContent.trim() !== '' &&
               !el.classList.contains('adeqo-policy__inline-toc-hidden');
      }
    );
    if (!nodes.length) return { top: 2, items: [] };

    var top = Math.min.apply(null, nodes.map(function (el) {
      return parseInt(el.tagName.slice(1), 10);
    }));

    var used = {};
    var items = nodes
      .filter(function (el) {
        return parseInt(el.tagName.slice(1), 10) <= top + 1;
      })
      .map(function (el) {
        return {
          el: el,
          id: ensureId(el, used),
          text: el.textContent.trim(),
          level: parseInt(el.tagName.slice(1), 10)
        };
      });

    return { top: top, items: items };
  }

  function buildToc(list, collected) {
    var frag = document.createDocumentFragment();
    var currentSub = null;

    collected.items.forEach(function (item) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + item.id;
      a.textContent = item.text;
      li.appendChild(a);

      // Een subkop vóór de eerste hoofdkop heeft geen ouder en gaat op hoofdniveau.
      if (item.level > collected.top && currentSub) {
        currentSub.appendChild(li);
        return;
      }

      currentSub = document.createElement('ol');
      currentSub.className = 'adeqo-policy__toc-list adeqo-policy__toc-list--sub';
      li.appendChild(currentSub);
      frag.appendChild(li);
    });

    list.innerHTML = '';
    list.appendChild(frag);
  }

  function initSpy(collected, list, rail) {
    var links = {};
    Array.prototype.forEach.call(list.querySelectorAll('a'), function (a) {
      links[a.getAttribute('href').slice(1)] = a;
    });

    var active = null;
    var queued = false;

    function apply() {
      queued = false;

      var current = collected.items[0];
      for (var i = 0; i < collected.items.length; i++) {
        if (collected.items[i].el.getBoundingClientRect().top > SCROLL_ANCHOR) break;
        current = collected.items[i];
      }
      if (!current || current.id === active) return;

      if (active && links[active]) links[active].removeAttribute('aria-current');
      active = current.id;
      var link = links[active];
      if (!link) return;
      link.setAttribute('aria-current', 'true');

      // Houd de actieve regel zichtbaar wanneer de zijkolom zelf scrolt.
      if (rail && rail.scrollHeight > rail.clientHeight + 4) {
        var railBox = rail.getBoundingClientRect();
        var linkBox = link.getBoundingClientRect();
        if (linkBox.top < railBox.top || linkBox.bottom > railBox.bottom) {
          rail.scrollTop += linkBox.top - railBox.top - railBox.height / 3;
        }
      }
    }

    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(apply);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    apply();
  }

  function init(root) {
    if (root.dataset.policyReady === 'true') return;
    root.dataset.policyReady = 'true';

    var body = root.querySelector('[data-policy-body]');
    var toc = root.querySelector('[data-policy-toc]');
    var list = root.querySelector('[data-policy-toc-list]');
    if (!body || !toc || !list) return;

    var minHeadings = parseInt(root.dataset.tocMin, 10) || 3;

    wrapTables(body);
    stripFillerWhitespace(body);
    normalise(body, minHeadings);
    if (root.dataset.hideInlineToc === 'true') hideInlineToc(body);

    var collected = collectHeadings(body);
    if (collected.items.length < minHeadings) return;

    buildToc(list, collected);
    toc.hidden = false;

    // Op desktop staat de lijst open en leest de samenvatting als kop; op mobiel
    // blijft het een uitklapbaar blok.
    var desktop = window.matchMedia(DESKTOP);
    function syncOpen() {
      toc.open = desktop.matches;
    }
    syncOpen();
    if (desktop.addEventListener) desktop.addEventListener('change', syncOpen);
    else if (desktop.addListener) desktop.addListener(syncOpen);

    initSpy(collected, list, root.querySelector('.adeqo-policy__aside'));
  }

  /* Op /policies/* rendert Shopify zijn eigen markup en accepteert het geen
     policy-template. layout/theme.liquid levert daarom een leeg skelet in een
     <template>; hier hangen we de titel en de tekst erin en zetten we het op de
     plek van het origineel. Mislukt dit, dan blijft Shopify's eigen weergave staan. */
  function adoptShopifyPolicy() {
    var shell = document.getElementById('adeqo-policy-shell');
    var source = document.querySelector('.shopify-policy__container');
    if (!shell || !source || document.querySelector('[data-adeqo-policy]')) return;

    var sourceBody = source.querySelector('.shopify-policy__body');
    var sourceTitle = source.querySelector('.shopify-policy__title h1, .shopify-policy__title');
    if (!sourceBody) return;

    var built = shell.content.firstElementChild
      ? shell.content.cloneNode(true).querySelector('[data-adeqo-policy]')
      : null;
    if (!built) return;

    // Shopify's eigen H1 is de bron voor de titel. Het skelet vult 'm alvast met
    // page_title zodat er ook zonder JS een kop staat, maar wat Shopify hier zelf
    // rendert weegt zwaarder dan wat wij in de layout gokken.
    var title = built.querySelector('[data-policy-title]');
    if (title && sourceTitle && sourceTitle.textContent.trim() !== '') {
      title.textContent = sourceTitle.textContent.trim();
      var crumb = built.querySelector('[data-policy-crumb]');
      if (crumb) crumb.textContent = title.textContent;
    }

    // De rich text verhuist als geheel, zodat er niets opnieuw geparsed wordt.
    var target = built.querySelector('[data-policy-body]');
    var rte = sourceBody.querySelector('.rte') || sourceBody;
    while (rte.firstChild) target.appendChild(rte.firstChild);

    source.parentNode.replaceChild(built, source);
  }

  function boot(scope) {
    if (!scope) adoptShopifyPolicy();
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-adeqo-policy]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
